import { render } from "./StopIconMap.vue?vue&type=template&id=9819e4fe&lang=pug"
const script = {}

import "./StopIconMap.vue?vue&type=style&index=0&id=9819e4fe&lang=scss"
script.render = render

export default script